import React, { useState } from 'react';
import Papa from 'papaparse';
import { Button, Container, Form } from 'react-bootstrap';

function CSVtoVCF() {
  const [csvFile, setCsvFile] = useState(null);

  const handleFileChange = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const generateVCard = (row) => {
    const name = (row.Name || '').replace(/[;,]/g, '').trim();
    const phone = (row.Mobile || '').trim();
    const email = row.Email && row.Email.trim() !== '' ? row.Email.trim() : 'zenovous@gmail.com';

    return [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `N:${name};;;;`,
      `FN:${name}`,
      `TEL;TYPE=CELL:${phone}`,
      `EMAIL:${email}`,
      'END:VCARD'
    ].join('\r\n'); // iPhone requires CRLF
  };

  const handleConvert = () => {
    if (!csvFile) return;

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const vcards = result.data.map(generateVCard).join('\r\n');
        const blob = new Blob([vcards], { type: 'text/vcard;charset=utf-8;' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'contacts.vcf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };

  return (
    <Container className="mt-5">
      <h3>CSV to iPhone-Compatible vCard (.vcf)</h3>
      <Form.Group controlId="formFile" className="mb-3">
        <Form.Label>Upload CSV</Form.Label>
        <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
      </Form.Group>
      <Button onClick={handleConvert} disabled={!csvFile}>Convert & Download</Button>
    </Container>
  );
}

export default CSVtoVCF;
